<template>
  <div id="outer_game_detail_outer">

    <ul class="breadcrumb">
      <li><a :href="breadSrc()">赛程表</a></li>
      <li><a class="active">赛事详情</a></li>
    </ul>

    <div v-if="matchData != null" style="display: flex;flex-direction: row;flex-wrap: nowrap;align-items: center;justify-content: center;">
      <div class="game_card_outer" v-if="matchData != null">
        <div v-if="matchData.started_at != undefined" class="game_card_date">{{timeText}}</div>
        <div class="game_card_team_left">
          <div>{{matchData.home_team.name.charAt(0)}}</div>
          <div>{{matchData.home_team.name}}</div>
        </div>
        <div class="game_card_team_vs" >
          <div>
            <img v-if="status == 0" src="../../assets/shl_home_schedule_card_vs.png" style="width: 56px;height: auto;">
            <div v-else class="game_card_teams_scores_vs">
              {{formatNumber(matchData.home_team_score) + ' : ' + formatNumber(matchData.away_team_score)}}
            </div>
          </div>
          <div>
            <span v-if="status == 0">未开始</span>
            <a v-else-if="status == 1"
               href="javascript:void(null);"
               @click="showLivingQrCode" >直播中</a>
            <span v-else>已结束</span>
          </div>
        </div>
        <div class="game_card_team_right" >
          <div>{{matchData.away_team.name.charAt(0)}}</div>
          <div>{{matchData.away_team.name}}</div>
        </div>
      </div>
    </div>


    <el-tabs v-if="matchData != null" tab-position="top" style="text-align: center;margin-top: 50px;">
      <el-tab-pane v-for="(item, index) in tabList" :key="'sub_tab_item_' + index" :label="item" >
        <div v-if="scoreList != null"  style="margin-top: 30px;">
          <div v-if="index == 0">
            <teams-member-list v-if="matchData.home_team != undefined" v-bind:team-data="matchData.home_team"></teams-member-list>
            <teams-member-list v-if="matchData.away_team != undefined" v-bind:team-data="matchData.away_team" style="margin-top: 30px;"></teams-member-list>
          </div>
          <div v-else >
            <team-videos-list></team-videos-list>
          </div>
        </div>
        <div v-else style="line-height: 200px;">暂无数据</div>

      </el-tab-pane>
    </el-tabs>


    <div id="live_code_img_outer" v-if="showLiveQrImg">
      <div>
        <img src="../../assets/shl_game_live_qr_code.jpeg" >
        <div style="font-size: 0.8rem;font-weight: bold;margin-top: 5px;">扫码二维码，观看比赛直播</div>
        <a class="iconfont close-button" href="javascript:void(null);" @click="showLiveQrImg = false">&#xe639;</a>
      </div>
    </div>

  </div>
</template>

<script>
  import GameHttpManager from '../../js/outer-games-http-define';
  import TeamsMemberList from "./TeamsMemberList";
  import TeamVideosList from "./TeamVideosList";
export default {
  name: "OuterGameDetail",
  components: {
    TeamsMemberList,
    TeamVideosList
  },
  data() {
    return {
      tabList: [
        '技术统计',
        '视频集锦'
      ],
      tabIndex: 0,
      dataInit: false,
      scheduleData: null,
      gameData: null,
      scoreList: null,
      matchData: null,
      showLiveQrImg: false,
      status: 0,
      timeFlag: null,
    }
  },
  mounted() {
    this.loadScheudleData();
    this.loadGameData();
    this.loadGamePlayersScoreData();

  },
  computed: {
    id() {
      let id = this.$route.query.id;
      return id == undefined ? null : id;
    },
    timeText() {
      let started_at = this.matchData.started_at;
      if (started_at == undefined) {
        return  '';
      }
      let startDate = this.$moment(this.matchData.started_at);
      // let endDate = this.$moment(this.innerItem.end_at);
      if (!startDate.isValid()) {
        return '数据有误';
      }
      let group = this.matchData.group;
      return startDate.format('yyyy.MM.DD HH:mm') + '—' + group;
    }
  },
  methods: {
    showLivingQrCode() {
      this.showLiveQrImg = true;
    },

    formatNumber(number) {
      if (number >= 10) {
        return number;
      }
      if (number < 0) {
        return number;
      }
      return '0' + number;
    },
    getStatus() {
      let startedTime = this.matchData.started_at;
      let ended_at = this.matchData.ended_at;
      if (startedTime == undefined) {
        return 0;
      }
      if (ended_at == undefined) {
        ended_at = 0;
      }
      let startDate = this.$moment(startedTime);
      let endDate = this.$moment(ended_at);
      if (!startDate.isValid() || !endDate.isValid()) {
        return 0;
      }

      let now = this.$moment();

      if (now - startDate < 0) {
        return 0;
      } else if (now - endDate <= 0 || ended_at == 0) {
        return 1;
      } else {
        return 2;
      }
    },

    breadSrc() {
      let l = this.$router.resolve({
        name: '',
        params: {
          id: this.$route.params.id,
        },
        query: {
          index: this.$route.query.index
        }
      });

      return l.href;
    },

    loadScheudleData() {
      let _this = this;
      let id = this.id;
      GameHttpManager.getScheduleDetail(id, function (data) {
        let status = data.status;
        if (status == 'success') {
          _this.scheduleData = data.data;
          _this.dealWithDataLoadSuccess();
        }
      }, function (data) {
        _this.dealWithDataLoadSuccess();
      });
    },
    loadGameData() {
      let _this = this;
      let id = this.id;
      GameHttpManager.getGameDetail(id, function (data) {
        let status = data.status;
        if (status == 'success') {
          _this.gameData = data.data;
          _this.dealWithDataLoadSuccess();
        }
      }, function (data) {
        _this.dealWithDataLoadSuccess();
      });
    },

    loadGamePlayersScoreData() {
      let _this = this;
      let id = this.id;
      GameHttpManager.getGamePlayerScoresData(id, function (data) {
        let status = data.status;
        if (status == 'success') {
          _this.scoreList = data.data;
          _this.dealWithDataLoadSuccess();
        }
      }, function (data) {
        _this.dealWithDataLoadSuccess();
      });
    },

    getPlayerScore(playerList, scoreList) {
      let tmp = [];
      for(let i = 0; i < playerList.length; i++) {
        let item = playerList[i];
        let obj = {
          item: item,
        };

        for (let j = 0; j < scoreList.length; j++) {
          let scoreItem = scoreList[j];
          if (item.id == scoreItem.player_id) {
            obj.score = scoreItem;
            break;
          }
        }
        if (obj.score == undefined) {
          obj.score == {}
        };
        tmp.push(obj);
      }
      return tmp;
    },

    dealWithDataLoadSuccess() {
      let gameData = this.gameData;
      let scheduleData = this.scheduleData;
      let scoreList = this.scoreList;
      if ( scheduleData == null) {
        return;
      }

      if (gameData != null) {
        scheduleData.home_team_score = gameData.home_team_score;
        scheduleData.away_team_score = gameData.away_team_score;
        scheduleData.started_at = gameData.started_at;
        scheduleData.ended_at = gameData.ended_at;
        scheduleData.home_team = gameData.home_team;
        scheduleData.away_team = gameData.away_team;
      }

      if (scoreList != null) {
        let homePlayers = scheduleData.home_team.players;
        let awayPlayers = scheduleData.away_team.players;
        let newAwayPlayers = this.getPlayerScore(awayPlayers, scoreList);
        let newHomePlayers = this.getPlayerScore(homePlayers, scoreList);
        scheduleData.home_team.players = newHomePlayers;
        scheduleData.away_team.players = newAwayPlayers;
      }

      this.matchData = scheduleData;
      if (this.timeFlag == null) {
        let _this = this;
        this.timerFlag = setInterval(function () {
          _this.status = _this.getStatus();
        }, 5 * 1000);
      }
      this.status = this.getStatus()
    },



    subMenuClicked(index) {
      this.tabIndex = index;
    }
  }
}
</script>

<style scoped>


  .game_card_outer {
    width: 260px;
    height: 130px;
    background-image: url("../../assets/shl_home_schedule_card_bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
    overflow: hidden;
    mask-clip: border-box;
    -ms-interpolation-mode: bicubic;
  }


  .game_card_date {
    text-align: center;
    margin-top: 15px;
    /*padding-top: 10px;*/
    color: white;
    /*font-size: 0.8rem;*/
    font-weight: bold;
  }
  .game_card_title {
    text-align: center;
    margin-right: 8px;
    margin-left: 8px;
    color: white;
    font-weight: bold;
    font-size: 1rem;
    letter-spacing: 1.5px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .game_card_team_left, .game_card_team_right, .game_card_team_vs {
    position: absolute;

  }

  .game_card_team_left {
    left: 21%;
    top: 33%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .game_card_team_right {
    right: 21%;
    top: 33%;
    transform: translateX(50%);
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .game_card_team_left > div:first-child, .game_card_team_right > div:first-child {
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border-radius: 25px;
    border: solid 1px transparent;
    font-size: 1.5rem;
  }

  .game_card_team_left > div:first-child {
    background-color: rgb(221,119,73);
    color: white;
  }

  .game_card_team_right > div:first-child {
    background-color: rgb(222, 164, 77);
    color: rgb(197, 8, 50);
  }

  .game_card_team_left > div:last-child, .game_card_team_right > div:last-child {
    color: white;
    font-size: 0.8rem;
    font-weight: bold;
    margin-top: 10px;
    text-align: center;
  }

  .game_card_team_vs {
    left: 32%;
    top: 35%;
    width: 36%;
  }
  .game_card_team_vs > div:first-child {
    height: 50px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .game_card_team_vs > div:last-child {
    color: white;
    font-size: 0.8rem;
    text-align: center;
    font-weight: bold;
  }

  .game_card_team_vs > div:last-child a {
    color: inherit;
  }

  .game_card_team_vs > div:last-child a:hover {
    color: #eee;
    text-decoration: none;
  }

  .game_card_teams_scores_vs {
    color: white;
    font-weight: bold;
    font-size: 1.5rem;
  }


  #game_detail_sub_menus {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    margin-top: 20px;
    max-width: 300px;
    width: 100%;
  }

  #game_detail_sub_menus > a {
    color: #333;
    text-decoration: none;
    font-weight: bold;
    font-size: 1rem;
  }

  #game_detail_sub_menus > a.active {
    color: #fc1a34;
    pointer-events: none;
  }


  #outer_game_detail_outer .breadcrumb {
    background-color: white;
  }

  #outer_game_detail_outer .breadcrumb a {
    text-decoration: none;
    color: #333;
    /*font-weight: bold;*/
  }

  #outer_game_detail_outer .breadcrumb a.active {
    color: #fc1a34;
  }


  #outer_game_detail_outer /deep/ .el-tabs .el-tabs__item.is-active {
    color: #fc1a34;
  }

  #outer_game_detail_outer /deep/ .el-tabs .el-tabs__item:hover {
    color: #fc1a34;
  }

  #outer_game_detail_outer /deep/ .el-tabs .el-tabs__active-bar {
    background-color: #fc1a34;
  }


  #outer_game_detail_outer /deep/ .el-tabs .el-tabs__nav-wrap::after {
    background-color: transparent;
  }

  #outer_game_detail_outer /deep/ .el-tabs .el-tabs__nav-scroll {
    /*background-color: blue;*/
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
  }

  #live_code_img_outer {
    width: 100vw;
    height: 100vh;
    background-color: rgba(0,0,0,0.3);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 500;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  #live_code_img_outer > div {
    width: 50vw;
    min-width: 290px;
    padding: 30px 15px;
    max-width: 350px;
    background-color: white;
    border-radius: 2px;
    position: relative;

    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: nowrap;
    justify-content: flex-start;
  }


  #live_code_img_outer .close-button {
    position: absolute;
    top: 0;
    right: 3px;
    color: black;
    font-size: 2rem;
    text-decoration: none;
    z-index: 999;
  }

  #live_code_img_outer > div > img {
    width: 90%;
    max-width: 250px;
    height: auto;
  }

</style>



// WEBPACK FOOTER //
// src/pages/outer-matches/OuterGameDetail.vue